/**
 * Feature flag keys that are registered in the application
 * This is the source of truth for all feature flags
 */
export const FEATURE_FLAGS = {
  "test-flag": "test-flag",
  "associate-product-v2-enabled": "associate-product-v2-enabled",
  "memory-bank-notes-enabled": "memory-bank-notes-enabled",
  "show-email-po-metrics-enabled": "show-email-po-metrics-enabled",
  "email-threads-enabled": "email-threads-enabled",
  "be-new-sales-order-flow-enabled": "be-new-sales-order-flow-enabled",
  "ap-invoices-ui-enabled": "ap-invoices-ui-enabled",
  "oms-ui-enabled": "oms-ui-enabled",
  "extend-ai-ocr-enabled": "extend-ai-ocr-enabled",
  "rbac-routing-enabled": "rbac-routing-enabled",
  "sales-order-upload-enabled": "sales-order-upload-enabled",
  "ap-invoice-ingestion-splitting-enabled":
    "ap-invoice-ingestion-splitting-enabled",
  "discount-validation-enabled": "discount-validation-enabled",
  "inventory-validation-enabled": "inventory-validation-enabled",
  "location-fuzzy-matching-enabled": "location-fuzzy-matching-enabled",
  "sales-order-drafts-ebs-org-filter-enabled":
    "sales-order-drafts-ebs-org-filter-enabled",
  "activity-log-enabled": "activity-log-enabled",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

// Payload type for each feature flag
export type FeatureFlagConfig = {
  "test-flag": boolean;
  "associate-product-v2-enabled": boolean;
  "memory-bank-notes-enabled": boolean;
  "show-email-po-metrics-enabled": boolean;
  "email-threads-enabled": boolean;
  "be-new-sales-order-flow-enabled": boolean;
  "ap-invoices-ui-enabled": boolean;
  "oms-ui-enabled": boolean;
  "extend-ai-ocr-enabled": boolean;
  "rbac-routing-enabled": boolean;
  "sales-order-upload-enabled": boolean;
  "ap-invoice-ingestion-splitting-enabled": boolean;
  "discount-validation-enabled": boolean;
  "inventory-validation-enabled": boolean;
  "location-fuzzy-matching-enabled": boolean;
  "sales-order-drafts-ebs-org-filter-enabled": boolean;
  "activity-log-enabled": boolean;
};

// Generic type for feature flag information
export type FlagInfo<Key extends FeatureFlagKey> = {
  enabled: boolean;
  variantKey?: string;
  payload?: FeatureFlagConfig[Key];
};
